import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./SelectUser.module.scss";

const SelectUser = ({
  allUser,
  changeUserIdWithSelect,
  searchUser,
  setSearchUser,
  userId,
  isSearchingUser,
  setIsSearchingUser,
}) => {
  const { t } = useTranslation();
  const filteredUser = allUser.filter(
    (u) =>
      u.display_name.toLowerCase().includes(searchUser) ||
      u.user_email.toLowerCase().includes(searchUser) ||
      u.ID.toString().includes(searchUser) ||
      u.user_login.toLowerCase().includes(searchUser)
  );

  return (
    <div className={styles.wrapper}>
      <input
        type="text"
        className={styles.searchInput}
        value={searchUser}
        onChange={(e) => {
          setSearchUser(e.target.value.toLowerCase());
          setIsSearchingUser(true);
        }}
        placeholder={t("common.search_user_placeholder")}
      />

      <select
        className={styles.selectUser}
        value={userId}
        onChange={changeUserIdWithSelect}
        size={isSearchingUser ? 10 : 1}
        onBlur={() => setIsSearchingUser(false)}
      >
        <option value="">{t("common.select_user_option")}</option>
        {filteredUser.length === 0 && (
          <option value="" disabled>
            {t("common.no_option_available")}
          </option>
        )}
        {allUser &&
          filteredUser
            .sort((a, b) => a.user_login.localeCompare(b.user_login))
            .map((c) => (
              <option key={c.ID} value={c.ID}>
                {c.user_login} {c.display_name} ({c.ID})
              </option>
            ))}
      </select>
    </div>
  );
};

export default SelectUser;
